export const getStatusStyles = (status) => {
    const s = (status || "").toUpperCase().replace(/[\s_]/g, '');
    switch (s) {
        case 'PRESENT':
        case 'ONTIME':
            return { badge: 'bg-[#DCFCE7] text-[#166534]', track: 'bg-[#22C55E]' };
        case 'LATE':
            return { badge: 'bg-[#FFEDD5] text-[#C2410C]', track: 'bg-[#EA580C]' };
        case 'ABSENT':
        case 'MISSINGPUNCH':
            return { badge: 'bg-[#FEE2E2] text-[#DC2626]', track: 'bg-[#DC2626]' };
        case 'HALFDAY':
            return { badge: 'bg-[#DBEAFE] text-[#1D4ED8]', track: 'bg-[#3B82F6]' };
        case 'SHORTFALL':
            return { badge: 'bg-[#FEF9C3] text-[#A16207]', track: 'bg-[#EAB308]' };
        case 'ONLEAVE':
            return { badge: 'bg-[#F3E8FF] text-[#6B21A8]', track: 'bg-[#A855F7]' };
        case 'ACTIVE':
            return { badge: 'bg-[#DCFCE7] text-[#166534]', track: 'bg-[#22C55E]' }; 
        default:
            return { badge: 'bg-gray-100 text-gray-600', track: 'bg-[#E2E8F0]' };
    }
};

export const formatTime = (isoString) => {
    if (!isoString) return "—";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return "—";
    return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
};

export const formatDate = (isoString) => {
    if (!isoString) return "—";
    return isoString.split("T")[0];
};

export const getDayOfWeek = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", { weekday: "short" });
};
